"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const idm_common_util_frontend_1 = require("@synisys/idm-common-util-frontend");
/**
 * A standard message object that components use to communicate with each other.
 * Besides its standard signature it is also an {@link IndexedValue},
 * so can hold any number of arbitrary properties if this is required.
 * The generic type 'T' is the type of component identification object.
 */
class SettingsMessage extends idm_common_util_frontend_1.IndexedValue {
    /**
     * Constructs and initializes the message.
     * If 'targets' is not specified the message is treated as broadcast and addressed to all.
     * @param {T} source which component is the author of this message
     * @param {T[]} targets optional value showing to which components is this message addressed
     */
    constructor(source, targets = []) {
        super();
        idm_common_util_frontend_1.PreconditionCheck.notNullOrUndefined(source);
        idm_common_util_frontend_1.PreconditionCheck.notNullOrUndefined(targets);
        this.time = Date.now();
        this.source = source;
        this.targets = new Set(targets);
        this.data = null;
    }
    /**
     * Helps to easily determine if the component with identifier is addressee of this message.
     * If no targets are specified then the message is treated as broadcast and addressed to all.
     * @param {T} target the component identifier to check against
     * @returns {boolean} true if it is one of addressees, false otherwise
     */
    isTargetedTo(target) {
        idm_common_util_frontend_1.PreconditionCheck.notNullOrUndefined(target);
        return this.targets === null || this.targets.has(target);
    }
}
exports.SettingsMessage = SettingsMessage;
//# sourceMappingURL=settings-message.js.map